exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choose-store .weui_cell_hd{display:none}.choose-store .choose-store-ul{background-color:#fff}.choose-store .choose-store-ul li{padding-left:.4rem;line-height:1.17333333rem;-webkit-box-shadow:0 1px 0 0 #e6e6e6;box-shadow:0 1px 0 0 #e6e6e6;font-size:.37333333rem}", ""]);

// exports
